var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { Stack, StackChildren, Text } from '@doordash/design-language';
import * as React from 'react';
import ButtonGroupModalFooter from './button_group_modal_footer';
import BulkAddToMemberStrings from './BulkAddToMemberStrings';
import TestIds from './TestIds';
import { AddTeamMembersToGroupByEmailErrorCode } from '../../../types/GloblalTypes';
import track from '../../../utils/track';
import { GroupsMembersEvents } from '../../../constants/events';
var strings = BulkAddToMemberStrings.informUserCannotAddEmail;
export var InviteTeamMemberErrorSections = function (_a) {
    var emails = _a.emails;
    if (emails.length === 0) {
        return null;
    }
    return (React.createElement(StackChildren, { "data-testid": TestIds.INFORM_EMAIL_ERRORS_INVITE_ERROR_CONTENT },
        React.createElement(Text, { styles: Text.Styles.Caption1 }, emails.length === 1
            ? strings.inviteToTeamAccount.singleFail()
            : strings.inviteToTeamAccount.multipleFail(emails.length)),
        React.createElement("ul", { "data-testid": TestIds.INFORM_EMAIL_ERRORS_INVITE_ERROR_EMAILS }, emails.map(function (email) {
            return (React.createElement("li", { key: email },
                ' ',
                React.createElement(Text, { styles: Text.Styles.Caption1 }, email)));
        }))));
};
export var AddToGroupErrorSections = function (_a) {
    var emails = _a.emails;
    if (emails.length === 0) {
        return null;
    }
    return (React.createElement(StackChildren, { "data-testid": TestIds.INFORM_EMAIL_ERRORS_ADD_TO_GROUP_ERROR_CONTENT },
        React.createElement(Text, { styles: Text.Styles.Caption1 },
            emails.length === 1
                ? strings.addToGroup.singleFail()
                : strings.addToGroup.multipleFail(emails.length),
            ' ',
            strings.tryAgain()),
        React.createElement("ul", { "data-testid": TestIds.INFORM_EMAIL_ERRORS_ADD_TO_GROUP_ERROR_EMAILS }, emails.map(function (email) {
            return (React.createElement("li", { key: email },
                ' ',
                React.createElement(Text, { styles: Text.Styles.Caption1 }, email)));
        }))));
};
export var InformUserCannotAddEmailContent = function (_a) {
    var group = _a.group, errors = _a.errors, onClose = _a.onClose, setTitle = _a.setTitle;
    var inviteTeamMemberErrors = React.useMemo(function () { var _a; return ((_a = errors.inviteTeamMemberErrors) !== null && _a !== void 0 ? _a : []).filter(function (err) { return !!err; }); }, [errors]);
    var addTeamMemberToGroupErrors = React.useMemo(function () { var _a; return ((_a = errors.addTeamMemberToGroupErrors) !== null && _a !== void 0 ? _a : []).filter(function (err) { return !!err; }); }, [errors]);
    React.useEffect(function () {
        track(GroupsMembersEvents.ADD_MODAL_INFORM_CANNOT_ADD, {
            group_id: group.id,
            group_name: group.name,
            add_error_count: (addTeamMemberToGroupErrors === null || addTeamMemberToGroupErrors === void 0 ? void 0 : addTeamMemberToGroupErrors.length) || 0,
            invite_error_count: (inviteTeamMemberErrors === null || inviteTeamMemberErrors === void 0 ? void 0 : inviteTeamMemberErrors.length) || 0,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // fire event on mount
    React.useEffect(function () {
        var allEmails = new Set(__spread(inviteTeamMemberErrors.map(function (err) { return err.email; }), addTeamMemberToGroupErrors.map(function (err) { return err.email; })));
        setTitle(allEmails.size > 1
            ? strings.modal.titleMultipleFail(allEmails.size)
            : strings.modal.titleSingleFail());
    }, [setTitle, inviteTeamMemberErrors, addTeamMemberToGroupErrors]);
    var emailsBelongsToOtherTeams = __spread(inviteTeamMemberErrors.map(function (error) {
        return error.email;
    }), addTeamMemberToGroupErrors
        .filter(function (error) {
        return (error.code ===
            AddTeamMembersToGroupByEmailErrorCode.ADD_TEAM_MEMBER_TO_GROUP_ERROR_CODE_MEMBER_BELONGS_TO_OTHER_TEAM);
    })
        .map(function (error) {
        return error.email;
    }));
    var emailsBelongToOtherTeams = new Set(emailsBelongsToOtherTeams);
    var processedEmailsBelongsToOtherTeams = __spread(emailsBelongToOtherTeams);
    var processedEmailsEncounteredRetryableErrors = addTeamMemberToGroupErrors
        .map(function (error) {
        return error.email;
    })
        .filter(function (email) { return !emailsBelongToOtherTeams.has(email); });
    return (React.createElement(React.Fragment, null,
        React.createElement(StackChildren, { size: Stack.Sizes.Medium, "data-testid": TestIds.INFORM_EMAIL_ERRORS_CONTENT },
            React.createElement(InviteTeamMemberErrorSections, { emails: processedEmailsBelongsToOtherTeams }),
            React.createElement(AddToGroupErrorSections, { emails: processedEmailsEncounteredRetryableErrors })),
        React.createElement(ButtonGroupModalFooter, { primary: {
                action: onClose,
                disabled: false,
                text: strings.button.primaryText(),
                loading: false,
            } })));
};
export default InformUserCannotAddEmailContent;
